// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import ContainerService from './ContainerService';

class ModalService {
  #modals = [];

  open(config) {
    return new Promise((resolve) => {
      const ModalWindow = this.#generateComponentWrapper({ ...config, closeHandler: resolve });
      const modalWindowInstance = new ModalWindow();

      ContainerService.appendComponent(modalWindowInstance);
      this.#collectModal(modalWindowInstance);
      modalWindowInstance.$el.focus();
    });
  }

  close(data) {
    const lastModal = this.#modals[this.#modals.length - 1];

    lastModal.close(data);
  }

  closeAll() {
    this.#modals.forEach((modal) => modal.close());
  }

  #collectModal(instance) {
    this.#modals.push(instance);
  }

  #removeModal(instance) {
    this.#modals = this.#modals.filter((modal) => modal !== instance);
  }

  #generateComponentWrapper({
    component,
    data,
    options = {},
    closeHandler,
  }) {
    const service = this;

    return Vue.component(`ModalWindow${component.name}`, {
      data() {
        return {
          showModal: true,
        };
      },
      methods: {
        hide() {
          this.showModal = false;
          // eslint-disable-next-line promise/param-names
          return new Promise((resolveHide) => {
            this.$el.addEventListener('animationend', resolveHide, { once: true });
          });
        },
        async close(result) {
          await this.hide();
          service.#removeModal(this);
          ContainerService.removeComponent(this);
          closeHandler(result);
        },
      },
      render(createElement) {
        return createElement(
          component,
          {
            props: {
              modalData: data,
              modalOptions: {
                overlayClickHandler: this.close,
                ...options,
              },
              showModal: this.showModal,
              closeHandler: this.close,
            },
          },
        );
      },
    });
  }
}

export default new ModalService();
